"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.plus_sankey_layout = exports.apply_transformation_opensankey_plus_elements = exports.SankeyPlusDiagramSelector = exports.plus_convert_data = void 0;
const SankeyPlusViews_1 = require("./SankeyPlusViews");
const OpenSankey_1 = require("./import/OpenSankey");
// Opensankey files
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = __importStar(require("react"));
const fa_1 = require("react-icons/fa");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
/* eslint-disable */
// @ts-ignore
const deep_diff = require('deep-diff');
/* eslint-enable */
const plus_convert_data = (data, DefaultSankeyData) => {
    data.background_image = (data.background_image === undefined) ? '' : data.background_image;
    data.show_background_image = (data.show_background_image === undefined) ? false : data.show_background_image;
    if (!data.labels) {
        data.labels = {};
    }
    if (!data.accordeonToShow.includes('LL') && Object.keys(data.labels).length > 0) {
        data.accordeonToShow.push('LL');
    }
    if (data.labels) {
        Object.values(data.labels).forEach((l) => {
            if (l.title === undefined) {
                let idZdt = Object.keys(data.labels).length;
                const tab_title = Object.values(data.labels).map(zdt => zdt.title);
                while (tab_title.includes('Zone de texte ' + idZdt)) {
                    idZdt = idZdt + 1;
                }
                l.title = 'Zone de texte ' + idZdt;
            }
            // CONVERT TEXT ZONE TRANSPARENT -> OPACITY (0-100)
            if (l.transparent !== undefined) {
                l.opacity = l.transparent ? 0 : 100;
                delete l.transparent;
            }
            if (l.name !== undefined) {
                const new_content = l.name;
                if (l.font_size === 40) {
                    l.content = new_content ? '<h3>' + new_content + '</h3>' : '';
                }
                else if (l.font_size === 30) {
                    l.content = new_content ? '<h4>' + new_content + '</h4>' : '';
                }
                else {
                    l.content = new_content ? new_content : '';
                }
                delete l.name;
            }
            const keys = ['idLabel', 'title', 'content', 'opacity', 'color', 'color_border', 'transparent_border', 'label_width', 'label_height', 'x', 'y', 'x_label', 'y_label', 'is_image', 'image_src'];
            const keys_to_remove = [];
            Object.keys(l).forEach(key => {
                if (!keys.includes(key)) {
                    keys_to_remove.push(key);
                }
            });
            keys_to_remove.forEach(key => delete l[key]);
            if (l.is_image === undefined) {
                l.is_image = false;
                l.image_src = '';
            }
        });
    }
    if (data.current_view === undefined) {
        data.current_view = 'none';
    }
    if (!data.view) {
        return;
    }
    const key_view = Object.values(data.view).map(v => v.id);
    if (data.current_view && data.current_view !== 'none' && !key_view.includes(data.current_view)) {
        data.current_view = 'none';
    }
    // Convert old view (when we copied the entire data)
    data.view.forEach((v) => {
        if (v.heredited_attr_from_master === undefined) {
            v.heredited_attr_from_master = [''];
        }
        if (v.view_data.version) {
            (0, OpenSankey_1.complete_sankey_data)(v.view_data, DefaultSankeyData, OpenSankey_1.DefaultNode, OpenSankey_1.DefaultLink);
            v.view_data.view = [];
            (0, OpenSankey_1.convert_tags)(v.view_data);
            (0, OpenSankey_1.convert_nodes)(v.view_data);
            (0, OpenSankey_1.convert_links)(v.view_data);
            (0, OpenSankey_1.convert_data)(v.view_data, DefaultSankeyData);
            (0, exports.plus_convert_data)(v.view_data, DefaultSankeyData);
            // let difference = deep_diff.diff(data, v.view_data)
            // difference=(difference!==undefined)?difference:[]
            // difference=JSON.parse(JSON.stringify(difference)).map((d:{path:string[],kind:string,item:{kind:string}})=>{
            //   if(d.kind==='D'){
            //     delete ((d as unknown) as differenceType).lhs
            //   }
            //   if(d.kind==='A' && d.item.kind==='D'){
            //     delete ((d as unknown) as differenceType).item.lhs
            //   }
            //   if(d.kind==='E'){
            //     delete ((d as unknown) as differenceType).lhs
            //   }
            //   return d
            // })
            // difference=difference.filter((d:{path:string[]})=>!d.path.includes('view'));
            // (v.view_data as {diff:object[]}) = {
            //   diff : difference
            // }
        }
        else if (v.view_data.diff !== undefined) {
            const d_view = (0, SankeyPlusViews_1.GetDataFromView)(data, v.id);
            (0, OpenSankey_1.convert_data)(d_view, DefaultSankeyData);
            (0, exports.plus_convert_data)(d_view, DefaultSankeyData);
            const copy_data = Object.assign({}, data);
            copy_data.view = [];
            const converted_master = JSON.parse(JSON.stringify(copy_data));
            (0, OpenSankey_1.convert_data)(converted_master, DefaultSankeyData);
            (0, exports.plus_convert_data)(converted_master, DefaultSankeyData);
            let difference = deep_diff.diff(converted_master, d_view);
            difference = (difference !== undefined) ? difference : [];
            difference = (0, SankeyPlusViews_1.FilterView)(difference);
            v.view_data = { diff: difference };
        }
    });
};
exports.plus_convert_data = plus_convert_data;
const SankeyPlusDiagramSelector = (master_data, set_master_data, view, view_selected, set_view_selected, DefaultSankeyData) => {
    const [s_diagram_type, sDiagramType] = (0, react_1.useState)('File');
    const SankeyPlusDiagramSelectorInner = (t, convert_data, sankey_data, set_sankey_data, prev_sankey_data, set_prev_sankey_data, updateLayout, elementToDispose) => {
        const [file_layout, set_file_layout] = (0, react_1.useState)(undefined);
        return react_1.default.createElement(react_bootstrap_1.InputGroup, null,
            react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.fmep')),
            react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '10%' }, variant: s_diagram_type === 'File' ? 'primary' : 'outline-primary', onClick: () => {
                    sDiagramType('File');
                } }, t('Menu.other_file')),
            react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '10%' }, variant: s_diagram_type === 'View' ? 'primary' : 'outline-primary', onClick: () => {
                    sDiagramType('View');
                } }, t('Menu.view_actual_file')),
            s_diagram_type === 'File' ? react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", onChange: (evt) => set_file_layout(evt.target.files) }) :
                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                        set_view_selected(evt.target.value);
                    } },
                    react_1.default.createElement("option", { key: 'none', value: 'none' }, t('view.actual')),
                    master_data ? master_data.view.map(d => {
                        return react_1.default.createElement("option", { key: d.id, value: d.id }, d.nom);
                    }) : react_1.default.createElement(react_1.default.Fragment, null)),
            react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '15%' }, onClick: () => {
                    if (s_diagram_type === 'View') {
                        if (view_selected === 'none') {
                            // View selected is master data
                            if (view === 'none') {
                                // No update of master data by master data
                                return;
                            }
                            //- current view is updated by master data
                            updateLayout(sankey_data, master_data, elementToDispose.current);
                            set_sankey_data(Object.assign({}, JSON.parse(JSON.stringify(sankey_data))));
                        }
                        else {
                            // A view is selected to update either another view or the master data
                            if (view === view_selected) {
                                // No update of view by itself
                                return;
                            }
                            const data_view = (0, SankeyPlusViews_1.GetDataFromView)(master_data, view_selected);
                            updateLayout(sankey_data, data_view, elementToDispose.current);
                            const copy_data = JSON.parse(JSON.stringify(sankey_data));
                            set_sankey_data(copy_data);
                            if (view === 'none') {
                                (0, SankeyPlusViews_1.RecomputeViews)(copy_data, master_data, set_master_data);
                            }
                        }
                        return;
                    }
                    if (file_layout === undefined) {
                        return;
                    }
                    const reader = new FileReader();
                    reader.onload = (() => {
                        return ((e) => {
                            let result = e.target.result;
                            if (result) {
                                result = String(result); //.split('<br>').join('\\\\n')
                                const new_layout = JSON.parse(result);
                                convert_data(new_layout, DefaultSankeyData);
                                (0, OpenSankey_1.complete_sankey_data)(new_layout, DefaultSankeyData, OpenSankey_1.DefaultNode, OpenSankey_1.DefaultLink);
                                set_prev_sankey_data(JSON.parse(JSON.stringify(sankey_data)));
                                updateLayout(sankey_data, new_layout, elementToDispose.current);
                                const copy_data = Object.assign({}, JSON.parse(JSON.stringify(sankey_data)));
                                set_sankey_data(copy_data);
                                if (view === 'none') {
                                    // if master is being updated we need to set it.
                                    set_master_data(copy_data);
                                }
                            }
                        });
                    })();
                    reader.readAsText(file_layout[0]);
                } }, t('Menu.Transformation.ad')),
            react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '15%' }, onClick: () => {
                    const copy_data = Object.assign({}, JSON.parse(JSON.stringify(prev_sankey_data)));
                    set_sankey_data(copy_data);
                    if (view === 'none') {
                        // if master is being updated we need to set it.
                        set_master_data(copy_data);
                    }
                } }, t('Menu.Transformation.undo')));
    };
    return SankeyPlusDiagramSelectorInner;
};
exports.SankeyPlusDiagramSelector = SankeyPlusDiagramSelector;
const apply_transformation_opensankey_plus_elements = (data, t, elementToDispose) => {
    // Variable used to check if we are in a view, if so we disabled the possibility to check Views in the menu transfromation
    const is_current_data_master = data.current_view === 'none';
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    return [
        react_1.default.createElement(react_bootstrap_1.InputGroup, null,
            react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.freeLabels')),
            react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('freeLabels') ? 'primary' : 'outline-primary', onClick: () => {
                    if (!elementToDispose.current.includes('freeLabels')) {
                        elementToDispose.current.push('freeLabels');
                        setForceUpdate(!forceUpdate);
                    }
                    else {
                        elementToDispose.current.splice(elementToDispose.current.indexOf('freeLabels'), 1);
                        setForceUpdate(!forceUpdate);
                    }
                } }, elementToDispose.current.includes('freeLabels') ? react_1.default.createElement(fa_1.FaCheck, null) : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faXmark }))),
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.4', placement: 'top', delay: 500, overlay: !is_current_data_master ? react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'transformation_view' },
                t('Menu.Transformation.disabled_view'),
                " ") : react_1.default.createElement(react_1.default.Fragment, null) },
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%',
                        color: (!is_current_data_master) ? '#666666' : '',
                        backgroundColor: (!is_current_data_master) ? '#cccccc' : '',
                    } }, t('Menu.Transformation.Views')),
                react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, disabled: !is_current_data_master, variant: elementToDispose.current.includes('Views') ? 'primary' : 'outline-primary', onClick: () => {
                        if (!elementToDispose.current.includes('Views')) {
                            elementToDispose.current.push('Views');
                            setForceUpdate(!forceUpdate);
                        }
                        else {
                            elementToDispose.current.splice(elementToDispose.current.indexOf('Views'), 1);
                            setForceUpdate(!forceUpdate);
                        }
                    } }, elementToDispose.current.includes('Views') ? react_1.default.createElement(fa_1.FaCheck, null) : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faXmark }))))
    ];
};
exports.apply_transformation_opensankey_plus_elements = apply_transformation_opensankey_plus_elements;
const plus_sankey_layout = (data, new_layout, mode) => {
    if (mode.includes('freeLabels') && new_layout.labels) {
        if (!data.labels) {
            data.labels = {};
        }
        const difference = deep_diff.diff(data.labels, new_layout.labels);
        if (difference) {
            difference.forEach((diff) => deep_diff.applyChange(data.labels, {}, diff));
        }
    }
    if (mode.includes('Views') && new_layout.view) {
        if (new_layout.view) {
            if (!(data.view)) {
                data.view = [];
            }
            new_layout.view.forEach((view_of_new_layout) => {
                const view_data = JSON.parse(JSON.stringify(new_layout));
                if (data.view.filter(d_view => d_view.nom === view_of_new_layout.nom).length === 0) {
                    if (view_of_new_layout.view_data.version) {
                        // Views are copied identical to what they were
                        view_of_new_layout.heredited_attr_from_master = [''];
                        // nodeId and linkId must be synchronized with new master
                        (0, OpenSankey_1.synchronizeNodesandLinksIdOSTyped)((view_of_new_layout.view_data), data);
                        data.view.push(view_of_new_layout);
                    }
                    else if (view_of_new_layout.view_data.diff !== undefined) {
                        view_of_new_layout.view_data.diff.forEach((diff) => deep_diff.applyChange(view_data, {}, diff));
                        // nodeId and linkId must be synchronized with new master
                        (0, OpenSankey_1.synchronizeNodesandLinksIdOSTyped)(view_data, data);
                        const data_view_diff = deep_diff.diff(data, view_data);
                        view_of_new_layout.view_data.diff = data_view_diff.filter((d) => !d.path.includes('view'));
                        // Views are copied identical to what they were
                        view_of_new_layout.heredited_attr_from_master = [''];
                        data.view.push(view_of_new_layout);
                    }
                }
            });
        }
    }
    if (mode.includes('attrNode')) {
        Object.entries(data.nodes).forEach(([key, node]) => {
            const layoutNode = new_layout.nodes[key];
            if (!layoutNode) {
                return;
            }
            // Add icon fromm imported layout if it has all the attribut 
            if (layoutNode.iconVisible !== undefined && layoutNode.iconColor && layoutNode.iconName) {
                node.iconVisible = layoutNode.iconVisible;
                node.iconColor = layoutNode.iconColor;
                node.iconName = layoutNode.iconName;
            }
            // Add ForeignObject from imported layout if it has all the attribut 
            if (layoutNode.has_FO !== undefined && layoutNode.is_FO_raw && layoutNode.FO_content) {
                node.has_FO = layoutNode.has_FO;
                node.is_FO_raw = layoutNode.is_FO_raw;
                node.FO_content = layoutNode.FO_content;
            }
        });
    }
};
exports.plus_sankey_layout = plus_sankey_layout;
